import React from "react";
import { Outlet, Navigate } from "react-router-dom";

import { useRequireAuth } from "../../hooks/usehooks.com/use-require-auth";

export default function RequireAuth({ children }) {
  const auth = useRequireAuth();
  if (auth) {
    return <Outlet />;
  }
  return null;
}
